import { render, staticRenderFns } from "./IrDevices.vue?vue&type=template&id=7fa7717d"
import script from "./IrDevices.vue?vue&type=script&lang=js"
export * from "./IrDevices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports